import TomSelect from 'tom-select';
import { Controller } from '@hotwired/stimulus'

export default class SchoolPopulatedSearchField extends Controller {
  static targets = ['select']

  connect() {
    this.tomSelect = new TomSelect(this.selectTarget, {
      hideSelected: true,
      persist: false,
      onItemAdd: function() {
        this.blur();
        this.control_input.removeAttribute('required');
      },
      onItemRemove: function() {
        this.control_input.setAttribute('required', 'required');
      },
      onInitialize: function() {
        this.input.removeAttribute('required'); // Remove required from the hidden select
        if (!this.input.value) this.control_input.setAttribute('required', 'required'); // Move required to the custom input
      }
    });
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }
  }
}
